import { getKsefInvoiceTypeOptions, getKsefPurchaseStatusOptions } from '../../modules/ksef/purchases/constants';
import FiltersType from './listingFiltersTypesConstants';

export const FILTERS = [
  {
    key: 'fulltext',
    placeholder: 'Wpisz frazę do znalezienia',
    shortPlaceholder: 'Szukaj',
    badge: 'Szukana fraza:',
    testName: 'hub_filter_search',
    inputType: FiltersType.TEXT_SEARCH_TYPE,
    reset: async () => ({ value: '' }),
  },
  {
    key: 'issue_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data wystawienia:',
    testName: 'test_filter_ksef_purchase_issue_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: '_total_net_amount',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota NETTO:',
    testName: 'test_filter_ksef_purchase_net_amount',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_total_gross_amount',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota BRUTTO:',
    testName: 'test_filter_ksef_purchase_gross_amount',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_display_status',
    getItems: async () => getKsefPurchaseStatusOptions(),
    reset: async () => null,
    placeholder: 'Status',
    badge: 'Status:',
    testName: 'test_filter_ksef_purchase_status',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
  {
    key: 'type',
    getItems: async () => getKsefInvoiceTypeOptions(),
    reset: async () => null,
    placeholder: 'Typ faktury',
    badge: 'Typ:',
    testName: 'test_filter_ksef_purchase_type',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
];
